/**
 * @description 内容适用阶段（售前/售后）在 TDC 枚举与 C 端 legacy code 之间的归一化
 * @reason TDC 返回 PRE_SALE / AFTER_SALE，商详资料 Tab 过滤依赖 1 / 2
 */

const APPLY_STAGE_TO_LEGACY = {
  1: 1,
  2: 2,
  PRE_SALE: 1,
  AFTER_SALE: 2,
  售前: 1,
  售后: 2,
  售前资料: 1,
  售后资料: 2,
}

/**
 * @description 将单条适用阶段值转为 legacy code（1 售前 / 2 售后）
 * @param {unknown} value - TDC 枚举、数字或中文标签
 * @returns {1|2|undefined}
 */
export function toLegacyContentApplyStage(value) {
  if (value === 1 || value === 2) return value

  const asNumber = Number(value)
  if (asNumber === 1 || asNumber === 2) return asNumber

  const mapped = APPLY_STAGE_TO_LEGACY[value] ?? APPLY_STAGE_TO_LEGACY[String(value || '').trim()]
  return mapped === 1 || mapped === 2 ? mapped : undefined
}

/**
 * @description 归一化适用阶段数组为 legacy code 列表
 * @param {unknown} value - applyStages 原始值
 * @returns {Array<1|2>}
 */
export function normalizeContentApplyStages(value) {
  const list = Array.isArray(value)
    ? value
    : value === undefined || value === null || value === ''
      ? []
      : [value]

  const codes = list
    .map((item) => toLegacyContentApplyStage(item))
    .filter((code) => code === 1 || code === 2)

  return Array.from(new Set(codes))
}

/**
 * @description 按适用阶段优先级排列内容，并将多阶段内容归入其最高优先级阶段一次。
 * @param {Array} items - 已按阶段内规则排好序的内容列表
 * @param {Array<1|2>} stageOrder - 阶段优先级
 * @returns {Array}
 */
export function orderContentByApplyStage(items, stageOrder = [1, 2]) {
  const source = Array.isArray(items) ? items : []
  const normalizedOrder = normalizeContentApplyStages(stageOrder)
  const effectiveOrder = normalizedOrder.length > 0 ? normalizedOrder : [1, 2]
  const ordered = []
  const added = new Set()

  effectiveOrder.forEach((stageCode, stageIndex) => {
    source.forEach((item) => {
      if (added.has(item)) return
      const stageCodes = normalizeContentApplyStages(item?.stageCodes ?? item?.applyStages)
      const belongsToStage =
        stageCodes.includes(stageCode) || (stageCodes.length === 0 && stageIndex === 0)
      if (!belongsToStage) return
      added.add(item)
      ordered.push(item)
    })
  })

  source.forEach((item) => {
    if (!added.has(item)) ordered.push(item)
  })

  return ordered
}
